import { intervalSelector } from '@src/store/common/selectors';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBarGranularity } from './utils';

const useParams = () => {
  const interval = useSelector(intervalSelector);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const params = useMemo(() => {
    const greaterThanADay = moment(interval.to).diff(moment(interval.from), 'hours') > 24;
    const olderThanThirtyDays = moment().diff(moment(interval.from), 'days') + 1 > 30;
    return {
      isIntervalValid: !(greaterThanADay || olderThanThirtyDays),
      granularity: getBarGranularity(interval),
    };
  }, [interval]);

  useEffect(() => {
    setSelectedIndex(null);
  }, [interval]);

  return { ...params, selectedIndex, setSelectedIndex };
};

export default useParams;
